import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/study-plan";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/study-plan")(
  enRouteOptions(routeOptions, {
    svPath: "/ovningsplan",
    title: "Study plan – Alkoholprovet",
    description: "Plan your practice sessions before the alcohol-serving knowledge test.",
    noindex: true,
  }),
);
